import stAttachmentAdd from './attachmentAdd.component';
import stAttachmentEdit from './attachmentEdit.component';
import stAttachmentMerge from './attachmentMerge.component';
import stAttachmentRename from './attachmentRename.component';
import stAttachmentsList from './attachmentsList.component';
import stAttachmentsListItem from './attachmentsListItem.component';

export default angular
  .module('st.Attachment', ['st.Core'])
  .component('stAttachmentAdd', stAttachmentAdd)
  .component('stAttachmentEdit', stAttachmentEdit)
  .component('stAttachmentMerge', stAttachmentMerge)
  .component('stAttachmentRename', stAttachmentRename)
  .component('stAttachmentsList', stAttachmentsList)
  .component('stAttachmentsListItem', stAttachmentsListItem)
  .service('attachmentsService', ($http, dataService, ATTACHMENT) => ({
    redactTFN: (params) =>
      dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        ATTACHMENT.API.REDACT_TFN,
        { params },
        null,
        true
      ),
    signatureRequest: (params) =>
      dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        ATTACHMENT.API.SIGNATURE_REQUEST,
        { params },
        null,
        true
      )
  }))
  .constant('ATTACHMENT', {
    API: {
      REDACT_TFN: '/api/v1/ticket/redact/tfn/',
      SIGNATURE_REQUEST: '/api/v1/integrations/e-sign/signature-request/'
    }
  });
